import { Component } from 'react';
import { Box, Text } from '@chakra-ui/react';



class CheckoutTimer extends Component {
  state = {
    barPercentage: 100,
    timeStamp: '',
    isLessThanOneMinute: false,
  };
  timer;

  componentDidMount() {
    this.setBarPercentage();
    this.setTimerTimestamp();
    this.timer = setInterval(this.updateTimer, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  updateTimer = () => {
    const currentTime = new Date();
    const { expiresAt, onExpire } = this.props;

    this.setBarPercentage();
    this.setTimerTimestamp();

    if (currentTime <= expiresAt) return;

    onExpire();
  };

  setBarPercentage = () => {
    const currentTime = new Date();
    const { expiresAt, onExpire, openAt } = this.props;

    const total = expiresAt - openAt;
    const current = currentTime - openAt;

    if (current < 0) onExpire();

    this.setState({ barPercentage: 100 - (current * 100) / total });
  };

  setTimerTimestamp = () => {
    const currentTime = new Date();
    const { expiresAt } = this.props;

    var delta = Math.abs(expiresAt - currentTime) / 1000;

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    var seconds = parseInt(delta % 60);

    // Verificar se o tempo restante é menor que um minuto
    const isLessThanOneMinute = minutes === 0;

    this.setState({
      timeStamp: isLessThanOneMinute 
        ? `${('' + seconds).padStart(2, '0')}` 
        : `${('' + minutes).padStart(2, '0')}:${('' + seconds).padStart(2, '0')}`,
      isLessThanOneMinute
    });
  };

  render() {
    const { isLessThanOneMinute, timeStamp } = this.state;

    return (
      <Box>
        <Box height="fit-content" bgColor="gray.100">
          <Box
            width={`${Math.floor(this.state.barPercentage)}%`}
            height="3px"
            bgColor="brand.500"
            transition="width 1s linear"></Box>
        </Box>

        <Text mt="4" px="5" textAlign="center" fontSize="sm">
          Em{' '}
          <span className="bold" style={{ width: 45 }}>
            {timeStamp}
          </span>{' '}
          <span className="bold">{isLessThanOneMinute ? 'segundos' : 'minutos'}</span> sua reserva será liberada.
        </Text>
      </Box>
    );
  }
}

export default CheckoutTimer;
